import "./CheckOutHeader.css";
import { ReactComponent as MainLogo } from "../../assets/icons/cleanBeeLogo.svg";
import { Link } from "react-router-dom";
import { useContext, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { setPageCount } from "../../state_management/actions";
import { stateType } from "../../store";
import { getServiceLink } from "../../utilities/misc";
import {
  disableSection,
  proceed_val_type
} from "../../state_management/reducers/order";
import { only_gift } from "../../utilities/cartUtilities";
import { cartInitialState } from "../../state_management/reducers/cart";
import { LocaleContext } from "../../AppProvider";

const CheckOutHeader = ({
  setPageCount,
  pageCount,
  orderSuccess,
  orderDirect,
  deactivate,
  cart
}: {
  setPageCount: (data: number) => void;
  pageCount: proceed_val_type;
  orderSuccess: boolean;
  orderDirect: boolean;
  deactivate?: boolean;
  cart: cartInitialState;
}) => {
  const { t, locale } = useContext(LocaleContext);
  const deactivateBars = deactivate || orderSuccess || orderDirect;
  const progressRef = useRef<HTMLDivElement>(null);

  const headerTile = [
    t("2. Extras"),
    t("3. Time"),
    t("4. Details"),
    t("5. Payment")
  ];

  useEffect(() => {
    progressRef.current?.scrollIntoView();
  }, [pageCount]);

  const service_link = getServiceLink(locale);
  const onlyGift = only_gift(cart);

  return (
    <div className="checkOutHeader_wrapper center fdCol">
      <div className="logo">
        <Link className="mainLogo_link" to={`/${service_link}`}>
          <MainLogo />
        </Link>
      </div>
      <p>
        <span className="fontBlue">
          <a
            className="fontBlue"
            href={`tel:${t("help_num").replace(/\)|\(|\s/g, "")}`}
          >
            {t("help_num")}
          </a>
        </span>
      </p>
      <div ref={progressRef} className="progress">
        {/* Step 0: Email / Cart */}
        <div
          onClick={() => {
            if (!deactivateBars) {
              setPageCount(0);
            }
          }}
          className={`item ${
            0 <= pageCount || deactivateBars ? `completed` : ``
          } fdCol ${pageCount === 0 ? `active` : ``} ${
            deactivateBars ? `deactivate` : ``
          }`}
        >
          <span className="flex1">{t("1. Cart")}</span>
          <div className="bar"></div>
        </div>
        {headerTile.map((title, n) => (
          <div
            onClick={() => {
              if (
                !disableSection((n + 1) as proceed_val_type, onlyGift) &&
                n + 1 <= pageCount &&
                !deactivateBars
              ) {
                setPageCount(n + 1);
              }
            }}
            key={n}
            className={`item ${
              n + 1 <= pageCount || deactivateBars ? `completed` : ``
            } fdCol ${pageCount === n + 1 ? `active` : ``} ${
              deactivateBars ? `deactivate` : ``
            }`}
          >
            <span className={`flex1`}>{title}</span>
            <div className="bar"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state: stateType) => ({
  cart: state.cartReducer,
  pageCount: state.commonReducer.pageCount,
  orderSuccess: state.orderReducer.success,
  orderDirect: state.orderReducer.direct
});

const mapDispatchToProps = (dispatch: (data: any) => any) => ({
  setPageCount: (data: number) => {
    dispatch(setPageCount(data));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckOutHeader);
